import Vue from 'vue'
import Appupcomponents from './index.vue' // 引入组件
const AppupConstructor = Vue.extend(Appupcomponents) // 返回一个“扩展实例构造器”
const Appup = (option = {}) => {
  return new AppupConstructor().init(option)
}
AppupConstructor.prototype.init = function(option = {}) {
  this.vm = this.$mount()
  this.isForce = option.isForce
  this.versionNo = option.versionNo
  this.url = option.url
  document.body.appendChild(this.$el)
}
AppupConstructor.prototype.remove = function() {
  this.show = false
  document.body.removeChild(this.$el)
  document.body.removeChild(document.querySelector('.van-overlay'))
}
export default Appup
